export default __webpack_public_path__ + "images/bottle-stone-4.svg";